import { render } from "./TopicDetail.vue?vue&type=template&id=49866c74&scoped=true"
import script from "./TopicDetail.vue?vue&type=script&lang=ts"
export * from "./TopicDetail.vue?vue&type=script&lang=ts"

import "./TopicDetail.vue?vue&type=style&index=0&id=49866c74&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-49866c74"

export default script